export class ThreatsFeedPipelineModel {
    id;
    name = null;
    pipelineDefinition = '';
}
//# sourceMappingURL=threats-feed-pipeline.js.map